/**
 * Formats a numeric string or number to a fixed two-decimal string.
 *
 * Ensures the result always includes exactly two decimal places, even if the input has fewer or no decimals.
 *
 * @param value - A number or numeric string to format.
 * @returns A string representation of the number with two decimal places.
 *
 * @example
 * formatToTwoDecimals("100");    // "100.00"
 * formatToTwoDecimals("100.4");  // "100.40"
 * formatToTwoDecimals("100.40"); // "100.40"
 */
export function formatToTwoDecimals(value: string | number): string {
  const num = Number(value);
  return num.toFixed(2);
}
